import { useEffect, useState } from "react";
import { fetchStanConfig, clearStanConfigCache } from "@internal/plugin-stan";

export const useStanConfig = () => {
  const [stanDisplayName, setStanDisplayName] = useState("STAN");

  useEffect(() => {
    clearStanConfigCache();
    fetchStanConfig()
      .then((config) => {
        setStanDisplayName(config.displayName);
      })
      .catch((_err) => {
        // STAN is being shelved; silently fall back to default display name
        setStanDisplayName("STAN");
      });
  }, []);

  return stanDisplayName;
};
